import { Router } from "@frui.ts/screens/dist";
import PaymentRetryViewModel, { PaymentRetryNavigationName } from "./paymentRetryViewModel";

export const SinglePaymentRetryNavigationName = PaymentRetryNavigationName;

@Router.registerRoute({ route: `${SinglePaymentRetryNavigationName}/:orderId`, name: Router.Self })
export default class SinglePaymentRetryViewModel extends PaymentRetryViewModel {}
